import {Route, Routes} from "react-router";
import Home from "./pages/Home";
import About from "./pages/About";
import MainLayout from "./layouts/MainLayout";
import Services from "./pages/Services";
import Contact from "./pages/Contact";


export default function Router (props) {
    return <Routes>
        <Route element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="blog" element={<></>} />
            <Route path="services" element={<Services />} />
            <Route path="contact" element={<Contact />} />
        </Route>
    </Routes>
}